// client/src/lib/auth.js
// Small auth helpers used by App.jsx and other pages.
// Safe: reads from multiple possible storage keys so we don't break older tokens.

const TOKEN_KEYS = [
  "ga_token",
  "authToken",
  "token",
  "jwt",
  "streamsite_token",
];

function safeGet(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(storage, key, value) {
  try {
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

function safeRemove(storage, key) {
  try {
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function getAuthToken() {
  // Prefer localStorage, but fall back to sessionStorage
  for (const key of TOKEN_KEYS) {
    const v1 = safeGet(window?.localStorage, key);
    if (v1) return v1;
    const v2 = safeGet(window?.sessionStorage, key);
    if (v2) return v2;
  }
  return "";
}

export function setAuthToken(token, { persist = true } = {}) {
  const storage = persist ? window?.localStorage : window?.sessionStorage;
  // Write to the first key (canonical), but keep others clean
  const canonical = TOKEN_KEYS[0];

  // Clear old keys first (prevents confusion)
  for (const key of TOKEN_KEYS) {
    safeRemove(window?.localStorage, key);
    safeRemove(window?.sessionStorage, key);
  }

  if (!token) return false;
  return safeSet(storage, canonical, token);
}

export function clearAuthToken() {
  let ok = true;
  for (const key of TOKEN_KEYS) {
    ok = safeRemove(window?.localStorage, key) && ok;
    ok = safeRemove(window?.sessionStorage, key) && ok;
  }
  return ok;
}

export function getAuthHeader() {
  const t = getAuthToken();
  return t ? `Bearer ${t}` : "";
}
